import React from 'react';
import { useTranslations } from 'use-intl';
import StepIndicator from '@/stories/Components/StepIndicator/StepIndicator';
import { RegistryStatus } from '@/graphql/__generated__/onboarding-legal';

interface StatusTimelineProps {
	registry: {
		registryStatus?: RegistryStatus | null;
	};
}

const StatusTimeline: React.FC<StatusTimelineProps> = ({ registry }) => {
	const t = useTranslations('RegistryDetails');

	const registrySteps = [
		t('ContactInformationStepStatusLegal'),
		t('CompanyInformationStepStatus'),
		t('CompanyDocumentationStepStatus'),
		t('LegalRepresentativeStepStatus'),
		t('PendingReview'),
		t('CorrectionsRequested'),
		t('ApprovedStatus')
	];

	const getStepIndex = (status: RegistryStatus | null | undefined): number => {
		if (!status) return 0;

		const stepMap: Record<RegistryStatus, number> = {
			[RegistryStatus.CONTACT_INFORMATION_REGISTERED]: 1,
			[RegistryStatus.COMPANY_INFORMATION_REGISTERED]: 2,
			[RegistryStatus.COMPANY_DOCUMENTATION_REGISTERED]: 3,
			[RegistryStatus.LEGAL_REPRESENTATIVE_REGISTERED]: 4,
			[RegistryStatus.COMPLETED]: 5,
			[RegistryStatus.APPROVED]: 6,
			[RegistryStatus.REJECTED]: 6
		};
		return stepMap[status] || 0;
	};

	const currentStep = getStepIndex(registry?.registryStatus);

	return <StepIndicator steps={registrySteps} currentStep={currentStep} />;
};

export default StatusTimeline;
